/// <amd-module name="Test/TestPlansHubRefresh/PostTTIModule/Redux/PostTTIModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { Modules } from "VSS/Redux/Modules";
import { PostTTIActions } from "./PostTTIActions";
import { PostTTISaga } from "./PostTTISaga";

export const PostTTIModule: ISagaModule<unknown> = {
    id: "test-hub-refresh-post-tti-module",
    sagas: [PostTTISaga],
    initialActions: [PostTTIActions.loadPostTTIModules()]
};

Modules.add("test-hub-refresh-post-tti-module", PostTTIModule);
